import React, { Component } from "react";
import ImageMessage from "./ImageMessage";
import EmojiMessage from "./EmojiMessage";
import VideoMessage from "./VideoMessage";
import LocationMessage from "./LocationMessage";
import AudioMessage from "./AudioMessage";
import TextMessage from "./TextMessage";
import CloseMessage from "./CloseMessage";
import CustomMessage from "./CustomMessage";
import DocumentMessage from "./DocumentMessage";
import { s360ConfigService } from "../../Services/S360Config";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";

class Message extends Component {
  showNewConversationOverlay = s360ConfigService.config.hideNewConversation;
  render() {
    console.log("MESSAGES TO RENDER", this.props.message);
    return <>{this.getMessageComponent()}</>;
  }

  getMessageComponent = () => {
    let convoType = this.props.message.convoType;

    switch (convoType) {
      case ConvoType.TEXT:
        return <TextMessage {...this.props} />;
      case ConvoType.EMOJI:
        return <EmojiMessage {...this.props} />;
      case ConvoType.IMAGE:
        return <ImageMessage {...this.props} />;
      case ConvoType.CUSTOM:
        return (
          <CustomMessage
            {...this.props}
            end={this?.props?.message?.message?.chatResponse?.end}
            disabled={this.props.message.disabled}
          />
        );
      case ConvoType.VIDEO:
        return <VideoMessage {...this.props} />;
      case ConvoType.AUDIO:
        return <AudioMessage {...this.props} />;
      case ConvoType.LOCATION:
        return <LocationMessage {...this.props} />;
      case ConvoType.FILE:
        return <TextMessage {...this.props} />;
      case ConvoType.CLOSE:
        return isNullOrUndefined(this.showNewConversationOverlay) ||
          !this.showNewConversationOverlay ? (
          <CloseMessage {...this.props} />
        ) : null;
      case ConvoType.TRANSFER:
        return <TextMessage {...this.props} />;
      case ConvoType.DOCUMENT:
        return <DocumentMessage {...this.props} />;
      default:
        return <TextMessage {...this.props} />;
    }
  };
}

export const ConvoType = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  CUSTOM: "CUSTOM",
  VIDEO: "VIDEO",
  AUDIO: "AUDIO",
  LOCATION: "LOCATION",
  FILE: "FILE",
  CLOSE: "CLOSE",
  TRANSFER: "TRANSFER",
  DOCUMENT: "DOCUMENT",
  EMOJI: "EMOJI",
};

export const MessageType = {
  received: "RECEIVED",
  sent: "SENT",
  info: "INFO",
};

export default Message;
